import React from 'react';
import { useTranslation } from 'react-i18next';
import './PrivacyNotice.css';
import Footer2 from '../footer';

const PrivacyNotice = () => {
  const { t } = useTranslation();
  
  return (
    <div className="privacy-notice">
      <div className="privacy-header">
        <div className="header-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
          <div className="decoration-circle circle-3"></div>
        </div>
        <h1 className="privacy-title">{t('privacy.title')}</h1>
        <p className="last-updated">{t('privacy.lastUpdated')}</p>
        <div className="header-line"></div>
      </div>

      <div className="privacy-intro">
        <p className="intro-text">{t('privacy.intro')}</p>
      </div>

      <div className="privacy-content">
        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">01</span>
            <h2>{t('privacy.section1.title')}</h2>
          </div>
          <p>{t('privacy.section1.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">02</span>
            <h2>{t('privacy.section2.title')}</h2>
          </div>
          <p>{t('privacy.section2.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">03</span>
            <h2>{t('privacy.section3.title')}</h2>
          </div>
          <p>{t('privacy.section3.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">04</span>
            <h2>{t('privacy.section4.title')}</h2>
          </div>
          <p>{t('privacy.section4.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">05</span>
            <h2>{t('privacy.section5.title')}</h2>
          </div>
          <p>{t('privacy.section5.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">06</span>
            <h2>{t('privacy.section6.title')}</h2>
          </div>
          <p>{t('privacy.section6.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">07</span>
            <h2>{t('privacy.section7.title')}</h2>
          </div>
          <p>{t('privacy.section7.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">08</span>
            <h2>{t('privacy.section8.title')}</h2>
          </div>
          <p>{t('privacy.section8.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">09</span>
            <h2>{t('privacy.section9.title')}</h2>
          </div>
          <p>{t('privacy.section9.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">10</span>
            <h2>{t('privacy.section10.title')}</h2>
          </div>
          <p>{t('privacy.section10.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">11</span>
            <h2>{t('privacy.section11.title')}</h2>
          </div>
          <p>{t('privacy.section11.content')}</p>
        </section>

        {/* <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">12</span>
            <h2>{t('privacy.section12.title')}</h2>
          </div>
          <p>{t('privacy.section12.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">13</span>
            <h2>{t('privacy.section13.title')}</h2>
          </div>
          <p>{t('privacy.section13.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">14</span>
            <h2>{t('privacy.section14.title')}</h2>
          </div>
          <p>{t('privacy.section14.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">15</span>
            <h2>{t('privacy.section15.title')}</h2>
          </div>
          <p>{t('privacy.section15.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">16</span>
            <h2>{t('privacy.section16.title')}</h2>
          </div>
          <p>{t('privacy.section16.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">17</span>
            <h2>{t('privacy.section17.title')}</h2>
          </div>
          <p>{t('privacy.section17.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">18</span>
            <h2>{t('privacy.section18.title')}</h2>
          </div>
          <p>{t('privacy.section18.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">19</span>
            <h2>{t('privacy.section19.title')}</h2>
          </div>
          <p>{t('privacy.section19.content')}</p>
        </section>

        <section className="privacy-section">
          <div className="section-header">
            <span className="section-number">20</span>
            <h2>{t('privacy.section20.title')}</h2>
          </div>
          <p>{t('privacy.section20.content')}</p>
        </section> */}
      </div>

      <div className="data-types-grid">
        <h3 className="grid-title">{t('privacy.dataTypes.title')}</h3>
        <div className="grid-container">
          <div className="data-type-card">
            <div className="data-icon">👤</div>
            <h4>{t('privacy.dataTypes.personal.title')}</h4>
            <p>{t('privacy.dataTypes.personal.content')}</p>
          </div>
          <div className="data-type-card">
            <div className="data-icon">🌐</div>
            <h4>{t('privacy.dataTypes.usage.title')}</h4>
            <p>{t('privacy.dataTypes.usage.content')}</p>
          </div>
          <div className="data-type-card">
            <div className="data-icon">🍪</div>
            <h4>{t('privacy.dataTypes.technical.title')}</h4>
            <p>{t('privacy.dataTypes.technical.content')}</p>
          </div>
          <div className="data-type-card">
            <div className="data-icon">📍</div>
            <h4>{t('privacy.dataTypes.location.title')}</h4>
            <p>{t('privacy.dataTypes.location.content')}</p>
          </div>
        </div>
      </div>

      <div className="privacy-footer mb-5">
        <div className="footer-line"></div>
        <p className="footer-text">{t('privacy.footer')}</p>
        <div className="contact-info">
          <p>{t('privacy.contact.email')}</p>
          {/* <p>{t('privacy.contact.phone')}</p> */}
        </div>
      </div>


      <Footer2 style={{ textAlign: 'center' }}>
              </Footer2>
    </div>
  );
};

export default PrivacyNotice;